<div class="card-wrapper">
  <div class="header">
    <!-- Navbar brand -->
    <div class="flex-row">
      <a class="link-content" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="42"/>
        </span>
        <span class="primary-color title-text">Caleidoscoop Academie</span>
      </a>
    </div>
    <!--/ Navbar brand -->
  </div>
  <div class="card card-additional-properties">
    <div class="card-body cb-w-80">
      <h1 class="primary-color ms-1">{{'PROFILE_INFO'|translate}}</h1>
      <p class="colour-red font-size-13 ms-1">* verplicht veld</p>
      <br>
      <form [formGroup]="accountForm" class="validate-form">
        <div class="row">
          <div class="col-6">
            <div class="mb-1">
              <div class="d-flex">
                <label for="firstName">{{'FIRST_NAME'|translate}}</label>
                <p class="colour-red margin-left-5">*</p>
              </div>
              <div class="input-group">
                <input
                  id="firstName"
                  autofocus=""
                  class="form-control"
                  formControlName="firstName"
                  [readonly]="true"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-1">
              <div class="d-flex">
                <label for="name">{{'LAST_NAME'|translate}}</label>
                <p class="colour-red margin-left-5">*</p>
              </div>
              <div class="input-group form-password-toggle input-group-merge">
                <input
                  id="name"
                  autofocus=""
                  class="form-control"
                  formControlName="name"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 mb-1">
              <div class="d-flex">
                <label for="accountEmail">{{'EMAIL'|translate}}</label>
                <p class="colour-red margin-left-5">*</p>
              </div>
              <div class="input-group">
                <input
                  id="accountEmail"
                  autofocus=""
                  class="form-control"
                  formControlName="accountEmail"
                />
              </div>
            <app-validation-message
              [inputControl]="accountForm.get('accountEmail')"
              [submitted]="submitted" [controlName]="'EMAIL'|translate">
            </app-validation-message>
          </div>
          <div class="col-6 mb-1">
            <div>
              <label for="phoneNumber">{{'PHONE_NUMBER'|translate}}</label>
              <div class="input-group">
                <input
                  id="phoneNumber"
                  autofocus=""
                  class="form-control"
                  formControlName="phoneNumber"
                />
              </div>
            </div>
            <app-validation-message
              [inputControl]="accountForm.get('phoneNumber')"
              [submitted]="submitted" [controlName]="'PHONE_NUMBER'|translate">
            </app-validation-message>
          </div>
        </div>

        <div class="d-flex ms-1">
            <div class="form-check-inline">
              <div class="d-flex">
                <p class="mb-0 ms-0">{{'CONTACT_PREFERENCE'|translate}}</p>
                <p class="colour-red margin-left-5 me-1">*</p>

                <div class="checkbox-container ps-1 me-1"
                     placement="bottom"
                     [ngbTooltip]="'SMS_DISABLED_TOOLTIP'|translate"
                     [disableTooltip]="!userPhoneNumberMissing()">
                  <input class="checkbox-decor"
                         id="customCheckbox1"
                         name="customCheckbox"
                         type="checkbox"
                         [value]="'SMS'"
                         (change)="onContactPreferenceChange($event)"
                         [disabled]="userPhoneNumberMissing()"
                         [checked]="validateSMSOptionCheck()"
                  />
                  <label class="checkbox-text"
                         for="customCheckbox1">{{'SMS'|translate}}</label>
                </div>
                <div class="checkbox-container ps-1">
                  <input class="checkbox-decor"
                         id="customCheckbox2"
                         name="customCheckbox"
                         type="checkbox"
                         [value]="'EMAIL'"
                         (change)="onContactPreferenceChange($event)"
                         [checked]="accountForm.value.contactByEmail"
                  />
                  <label class="checkbox-text"
                         for="customCheckbox2">{{'E-mail'|translate}}</label>
                </div>
              </div>
            </div>
        </div>
        <span *ngIf="contactMissing" class="input-error contact-missing">Contactvoorkeur is verplicht</span>

        <br>
        <div class="ms-3p">
          <p>{{'BILLING_ADDRESS'|translate}}</p>
          <div class="border-group">
            <ng-container formGroupName="billingAddress">
              <div class="row">
                <div class="col-6 mb-1">
                  <div>
                    <div class="d-flex">
                      <label for="billingAddressCity">{{'CITY'|translate}}</label>
                      <p class="colour-red margin-left-5">*</p>
                    </div>
                    <div class="input-group">
                      <input
                        id="billingAddressCity"
                        autofocus=""
                        class="form-control"
                        formControlName="city"
                      />
                    </div>
                  </div>
                  <app-validation-message
                    [inputControl]="accountForm.get('billingAddress.city')"
                    [submitted]="submitted" [controlName]="'CITY'|translate">
                  </app-validation-message>
                </div>
                <div class="col-6 mb-1">
                  <div>
                    <div class="d-flex">
                      <label for="billingAddressPostcode">{{'POSTCODE'|translate}}</label>
                      <p class="colour-red margin-left-5">*</p>
                    </div>
                    <div class="input-group">
                      <input
                        id="billingAddressPostcode"
                        autofocus=""
                        class="form-control"
                        formControlName="postcode"
                      />
                    </div>
                  </div>
                  <app-validation-message
                    [inputControl]="accountForm.get('billingAddress.postcode')"
                    [submitted]="submitted" [controlName]="'POSTCODE'|translate">
                  </app-validation-message>
                </div>
              </div>

              <div class="row">
                <div class="col-6 mb-1">
                  <div>
                    <div class="d-flex">
                      <label for="billingAddressStreet">{{'STREET'|translate}}</label>
                      <p class="colour-red margin-left-5">*</p>
                    </div>
                    <div class="input-group">
                      <input
                        id="billingAddressStreet"
                        autofocus=""
                        class="form-control"
                        formControlName="street"
                      />
                    </div>
                  </div>
                  <app-validation-message
                    [inputControl]="accountForm.get('billingAddress.street')"
                    [submitted]="submitted" [controlName]="'STREET'|translate">
                  </app-validation-message>
                </div>
                <div class="col-6 mb-1">
                  <div>
                    <div class="d-flex">
                      <label for="billingAddressNumber">{{'STREET_NUMBER'|translate}}</label>
                      <p class="colour-red margin-left-5">*</p>
                    </div>
                    <div class="input-group">
                      <input
                        id="billingAddressNumber"
                        autofocus=""
                        class="form-control"
                        formControlName="number"
                      />
                    </div>
                  </div>
                  <app-validation-message
                    [inputControl]="accountForm.get('billingAddress.number')"
                    [submitted]="submitted" [controlName]="'STREET_NUMBER'|translate">
                  </app-validation-message>
                </div>
              </div>
              <div class="row">
                <div class="col-6 mb-1">
                  <div class="d-flex mb-1">
                    <p class="mb-0 ms-0">{{'IS_PRIVATE_PURCHASE'|translate}}</p>
                    <p class="colour-red margin-left-5 me-1">*</p>
                  </div>

                  <div class="d-flex">
                    <div class="checkbox-container ps-1 me-1">
                      <input class="checkbox-decor"
                             id="c1"
                             name="customCheckbox"
                             type="checkbox"
                             [value]="'Ja'"
                             (change)="onPrivatePurchaseChange($event, 'yes')"
                             [checked]="privatePurchaseCheck"
                      />
                      <label class="checkbox-text"
                             for="customCheckbox1">{{'YES'|translate}}</label>
                    </div>
                    <div class="checkbox-container ps-1">
                      <input class="checkbox-decor"
                             id="c2"
                             name="customCheckbox"
                             type="checkbox"
                             [value]="'Nee'"
                             (change)="onPrivatePurchaseChange($event, 'no')"
                             [checked]="!privatePurchaseCheck"
                      />
                      <label class="checkbox-text"
                             for="customCheckbox2">{{'NO'|translate}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-6 mb-1">
                  <div>
                    <div class="d-flex mb-1">
                      <label for="billingOrganizationName">{{'ORGANISATION_NAME'|translate}}</label>
                      <p *ngIf="!privatePurchaseCheck" class="colour-red margin-left-5 me-1">*</p>
                    </div>
                    <div class="input-group">
                      <input
                        id="billingOrganizationName"
                        autofocus=""
                        class="form-control"
                        formControlName="organizationName"
                        [readOnly]="privatePurchaseCheck"
                      />
                    </div>
                  </div>
                  <app-validation-message
                    [inputControl]="accountForm.get('billingAddress.organizationName')"
                    [submitted]="submitted" [controlName]="'ORGANISATION'|translate">
                  </app-validation-message>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <br>
        <div class="checkbox-container">
          <input
            type="checkbox"
            id="subscribe-to-emag"
            class="checkbox-decor min-width-18"
            formControlName="subscribeToEmag"
          />
          <label for="subscribe-to-emag" class="checkbox-text">{{'WANT_SUBSCRIBE_TO_EMAG' | translate}}</label>
        </div>

        <ng-container *ngIf="accountForm.get('subscribeToEmag').value">
          <div class="checkbox-container mt-1">
            <input
              type="checkbox"
              id="is-shipping-as-billing"
              class="checkbox-decor min-width-18"
              formControlName="isShippingSameAsBilling"
            />
            <label for="is-shipping-as-billing" class="checkbox-text">{{'SHIPPING_SAME_AS_BILLING_ADDRESS' | translate}}</label>
          </div>

          <div class="ms-3p" *ngIf="!accountForm.get('isShippingSameAsBilling').value">
            <p class="mt-1">{{'SHIPPING_ADDRESS'|translate}}</p>
            <div class="border-group">
              <ng-container formGroupName="shippingAddress">
                <div>
                  <div class="row">
                    <div class="col-6 mb-1">
                      <div>
                        <div class="d-flex">
                          <label for="shippingAddressCity">{{'CITY'|translate}}</label>
                          <p class="colour-red margin-left-5">*</p>
                        </div>
                        <div class="input-group">
                          <input
                            id="shippingAddressCity"
                            autofocus=""
                            class="form-control"
                            formControlName="city"
                          />
                        </div>
                      </div>
                      <app-validation-message
                        [inputControl]="accountForm.get('shippingAddress.city')"
                        [submitted]="submitted" [controlName]="'CITY'|translate">
                      </app-validation-message>
                    </div>
                    <div class="col-6">
                      <div class="mb-1">
                        <div class="d-flex">
                          <label for="shippingAddressPostcode">{{'POSTCODE'|translate}}</label>
                          <p class="colour-red margin-left-5">*</p>
                        </div>
                        <div class="input-group">
                          <input
                            id="shippingAddressPostcode"
                            autofocus=""
                            class="form-control"
                            formControlName="postcode"
                          />
                        </div>
                      </div>
                      <app-validation-message
                        [inputControl]="accountForm.get('shippingAddress.postcode')"
                        [submitted]="submitted" [controlName]="'POSTCODE'|translate">
                      </app-validation-message>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6 mb-1">
                      <div>
                        <div class="d-flex">
                          <label for="shippingAddressStreet">{{'STREET'|translate}}</label>
                          <p class="colour-red margin-left-5">*</p>
                        </div>
                        <div class="input-group">
                          <input
                            id="shippingAddressStreet"
                            autofocus=""
                            class="form-control"
                            formControlName="street"
                          />
                        </div>
                      </div>
                      <app-validation-message
                        [inputControl]="accountForm.get('shippingAddress.street')"
                        [submitted]="submitted" [controlName]="'STREET'|translate">
                      </app-validation-message>
                    </div>
                    <div class="col-6 mb-1">
                      <div>
                        <div class="d-flex">
                          <label for="shippingAddressNumber">{{'STREET_NUMBER'|translate}}</label>
                          <p class="colour-red margin-left-5">*</p>
                        </div>
                        <div class="input-group">
                          <input
                            id="shippingAddressNumber"
                            autofocus=""
                            class="form-control"
                            formControlName="number"
                          />
                        </div>
                      </div>
                      <app-validation-message
                        [inputControl]="accountForm.get('shippingAddress.number')"
                        [submitted]="submitted" [controlName]="'STREET_NUMBER'|translate">
                      </app-validation-message>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6 mb-1">
                      <div>
                        <div class="d-flex">
                          <label for="shippingOrganizationName">{{'SENDING_ORGANISATION_NAME'|translate}}</label>
                          <p class="colour-red margin-left-5">*</p>
                        </div>
                        <div class="input-group">
                          <input
                            id="shippingOrganizationName"
                            autofocus=""
                            class="form-control"
                            formControlName="organizationName"
                          />
                        </div>
                      </div>
                      <app-validation-message
                        [inputControl]="accountForm.get('shippingAddress.organizationName')"
                        [submitted]="submitted" [controlName]="'ORGANISATION'|translate">
                      </app-validation-message>
                    </div>
                  </div>

                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <br>
        <p >{{'ORGANISATION_FUNCTION'|translate}}</p>
        <div class="organisatie-group">
          <div class="control-group">
            <app-dropdown-with-input [options]="organizations"
                                     (selectOption)="setOrganiser($event)"
                                     [title]="'ORGANISATION'"
                                     [mandatoryAsterix]="true"
            >
            </app-dropdown-with-input>
            <span *ngIf="submitted && (!accountForm.get('organiser').value)" class="org-func-error">{{'ORGANISATION' | translate}} {{'IS_REQUIRED' | translate}}</span>
          </div>

          <div class="control-group">
            <app-dropdown-with-input (selectOption)="setFunctions($event)"
                                     [options]="functions"
                                     [title]="'FUNCTION'"
                                     [mandatoryAsterix]="true"
            >
            </app-dropdown-with-input>
            <span *ngIf="submitted && (!accountForm.get('function').value)" class="org-func-error">{{'FUNCTION' | translate}} {{'IS_REQUIRED' | translate}}</span>
          </div>
        </div>

        <br>
        <div class="mb-1">
          <div class="d-flex">
            <input
              type="checkbox"
              id="privacy-statement"
              class="checkbox-decor"
              formControlName="privacyStatement"
            />
            <span class="checkbox-text">{{'AGREE_WITH_PRIVACY_STATEMENT' | translate}}
              <a href="https://www.vrijclb.be/privacyverklaring-vrij-clb-netwerk" target="_blank" rel="noopener noreferrer">{{'PRIVACY' | translate}}</a>
            </span>
            <p class="colour-red margin-left-5">*</p>
          </div>
          <div class="ms-1">
            <app-validation-message
              [inputControl]="accountForm.get('privacyStatement')"
              [submitted]="submitted" [controlName]="'AGREE_WITH_PRIVACY_STATEMENT_ERROR'|translate">
            </app-validation-message>
          </div>
        </div>
        <div class="mb-1">
          <div class="d-flex">
            <input
              type="checkbox"
              id="terms-statement"
              class="checkbox-decor"
              formControlName="termsStatement"
            />
            <span class="checkbox-text">{{'AGREE_WITH_TERMS_STATEMENT' | translate}}
              <a href="https://www.vrijclb.be/disclaimer" target="_blank" rel="noopener noreferrer">{{'CONDITIONS_STATEMENT' | translate}}</a>
            </span>
            <p class="colour-red margin-left-5">*</p>
          </div>
          <div class="ms-1">
            <app-validation-message
              [inputControl]="accountForm.get('termsStatement')"
              [submitted]="submitted" [controlName]="'AGREE_WITH_TERMS_STATEMENT_ERROR'|translate">
            </app-validation-message>
          </div>
        </div>
        <div class="button-row">
            <button (click)="saveAccount()" class="btn btn-secondary right-button mt-1" rippleEffect
                    type="submit">{{'SAVE_PROFILE'|translate}}
            </button>
        </div>
      </form>
    </div>
  </div>
</div>
